<div class="film" [class.hidden]="hidden()" (click)="onClose()">
    <div class="film-item" [ngStyle]="style()" (click)="onStop($event)">
        <ng-container [dynamic]="data()?.model"></ng-container>
    </div>
</div>
